import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=8dc8040a&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=ts&"
export * from "./Detail.vue?vue&type=script&lang=ts&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=8dc8040a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc8040a",
  null
  
)

export default component.exports